import { Navigate } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { useAuth } from '@/contexts/AuthContext'

export default function Logout() {
  const { logout, isAuthenticated, loading } = useAuth()
  const logoutCalledRef = useRef(false)

  useEffect(() => {
    if (loading || logoutCalledRef.current) return
    logoutCalledRef.current = true

    if (isAuthenticated) {
      void logout()
    }
  }, [loading, isAuthenticated, logout])

  // Not authenticated (already logged out or logout completed for direct sessions)
  if (!loading && !isAuthenticated) {
    return <Navigate to="/" />
  }

  return (
    <div className="flex justify-center items-center h-dvh">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  )
}
